<template>
  <div>
    <DownloadChart
      @click="downloadCanvas('durationChart', 'titleDurationChart')"
    />
    <div ref="durationChart" class="p-1">
      <h3 ref="titleDurationChart" class="hidden mt-4 text-lg">
        Corruption Cases By Duration
      </h3>
      <BarChart
        :width="width"
        :height="height"
        :chart-data="data"
        :options="options"
      />
      <div v-if="showPercentages" class="mt-8">
        <div class="flex items-center mt-2">
          <div class="w-2 h-2 bg-0to5 rounded-full mr-3"></div>
          <span class="truncate">0 - 5 Years</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((cases0to5 / totalCases) * 100) | percentage }}
          </span>
        </div>
        <div class="flex items-center mt-3">
          <div class="w-2 h-2 bg-6to10 rounded-full mr-3"></div>
          <span class="truncate">6 - 10 Years</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((cases6to10 / totalCases) * 100) | percentage }}
          </span>
        </div>
        <div class="flex items-center mt-3">
          <div class="w-2 h-2 bg-11to15 rounded-full mr-3"></div>
          <span class="truncate">>= 11 Years</span>
          <div
            class="h-px flex-1 border border-r border-dashed border-gray-300 mx-3 xl:hidden"
          ></div>
          <span class="font-medium xl:ml-auto">
            {{ ((cases11to15 / totalCases) * 100) | percentage }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    showPercentages: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cases0to5: 0,
      cases6to10: 0,
      cases11to15: 0
    };
  },
  computed: {
    filterParams() {
      return this.$store.state.filtersMenu.selectedFilters;
    },
    totalCases() {
      return this.cases0to5 + this.cases6to10 + this.cases11to15;
    },
    data() {
      return {
        labels: ["0 - 5 years", "6 - 10 years", "11 - 15 years"],
        datasets: [
          {
            data: [this.cases0to5, this.cases6to10, this.cases11to15],
            backgroundColor: ["#339966", "#a2b86c", "#b6142c"],
            hoverBackgroundColor: ["#339966", "#a2b86c", "#b6142c"],
            borderWidth: 1,
            borderColor: this.$store.state.main.darkMode ? "#303953" : "#fff"
          }
        ]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ]
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function(tooltipItems) {
              return tooltipItems.yLabel;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 210
      };
    }
  },
  watch: {
    "$store.state.filtersMenu.count": {
      handler: function() {
        this.run();
      }
    }
  },
  mounted() {
    this.run();
  },
  methods: {
    run() {
      axios
        .get(`${window.host}/api/cases-duration`, {
          params: this.filterParams
        })
        .then(response => {
          if (response.data) {
            this.cases0to5 = response.data.cases0to5;
            this.cases6to10 = response.data.cases6to10;
            this.cases11to15 = response.data.cases11to15;
          }
        });
    }
  }
};
</script>

<style>
.bg-0to5 {
  background-color: #339966;
}
.bg-6to10 {
  background-color: #a2b86c;
}
.bg-11to15 {
  background-color: #b6142c;
}
</style>
